import {Link} from 'react-router-dom'

function Footer() {
  const footerYear = new Date().getFullYear()
  return (
    <footer className="footer p-6 bg-base-300 footer-center">
      <div>
        <p>
          <Link 
            to="/user/rilindtasholli" 
          > &copy;Rilind Tasholli</Link> - <span className="text-primary">Github App</span> - {footerYear}
        </p>
      </div>
    </footer>
  )
}

export default Footer
